import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Desktop, Mobile } from '../../App';
import { ViewBackOffice } from '../../styles/stylesStyled';
import { AirdropItemBox, AirdropsTableBody } from './AirdropsStyled';

import airdrops from '../../assets/images/backoffice/airDrop/airdrops.png';
import airdropsMobile from '../../assets/images/backoffice/airDrop/airdropsMobile.png';
import { CaptionText, H2, H3, H4, P2 } from '../../styles/FontStyles';

import { color } from '../../styles/GlobalStyles';
import { AirdropsTableHeader } from './AirdropsTableHeader';

import { AirdropItem } from './AirdropItem';

import { AirdropItemMobilee } from './AirdropItemMobile';
import { getAirdrops } from './Airdrop.actions';
import Spinner from '../../components/common/Spinner';

export const Airdrops = () => {
  const dispatch = useAppDispatch();

  const { tokens, loading } = useAppSelector((state) => state.airdrops);

  useEffect(() => {
    dispatch(getAirdrops());
  }, [dispatch]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <ViewBackOffice>
      <Desktop>
        <img src={airdrops} alt='dubaiPromo' style={{ width: '100%' }} />

        <H2 maxWidth='70%' m='20px'>
          {`AIRDROPS - Be a part of the Crypto Revolution `}
        </H2>

        <P2 color={color.colors.neutral500} maxWidth='70%' m='20px'>
          {`*You are eligible to receive Airdrops if you have a paid Back-office subscription. `}
        </P2>

        <AirdropsTableHeader />

        <AirdropsTableBody>
          {tokens?.tokens?.map((airdrop: any, index: number) => {
            return (
              <AirdropItemBox
                key={index}
                style={{
                  borderBottom:
                    index !== tokens.tokens.length - 1
                      ? '1px solid rgba(220, 220, 220)'
                      : 'none'
                }}>
                <AirdropItem
                  airdrop={airdrop}
                  licence={tokens.hasActiveLicence}
                  key={index}
                />
              </AirdropItemBox>
            );
          })}
        </AirdropsTableBody>
      </Desktop>
      <Mobile>
        <img src={airdropsMobile} alt='dubaiPromo' style={{ width: '100%' }} />
        <H4 maxWidth='70%' m='10px'>
          {`AIRDROPS - Be a part of the Crypto Revolution `}
        </H4>

        <CaptionText color={color.colors.neutral500} maxWidth='70%' m='10px'>
          {`*You are eligible to receive Airdrops if you have a paid Back-office subscription. `}
        </CaptionText>

        {/* {tokens?.tokens?.map((airdrop: any, index: number) => {
          return (
            <AirdropItemMobilee
              airdrop={airdrop}
              key={index}
              licence={tokens?.hasActiveLicence}
            />
          );
        })} */}
      </Mobile>
    </ViewBackOffice>
  );
};
